// @vue/component
export default {
  name: 'ReportsFormExportItemDatepickerTime',

  props: {
    currentField: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      fieldValue: this.currentField.default_value,
    };
  },
};
